<template>
  <div>
    <v-bottom-navigation
      horizontal
      grow
      fixed
      active-class="admin-bottom-nav__button--active"
      class="admin-bottom-nav"
    >
    <v-btn  
      value="home" 
      border="right"
      @pointerdown.stop.prevent="pointerMode && $router.push({ name: 'home' })"
      @click.stop.prevent="!pointerMode && $router.push({ name: 'home' })"
      to="/home"
    >
      <span>Home</span>

      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-divider vertical v-if="employeeAccess.report && employeeAccess.report.view"></v-divider>

    <v-btn v-if="employeeAccess.report && employeeAccess.report.view"
      value="Report"
      @pointerdown.stop.prevent="
        pointerMode && $router.push({ path: '/reports' })
      "
      @click.stop.prevent="!pointerMode && $router.push({ path: '/reports' })"
      to="/reports"
    >
      <span>Report</span>

      <v-icon>mdi-chart-areaspline</v-icon>
    </v-btn>

    <v-divider vertical></v-divider>

    <v-btn
      value="settings"
      @click.stop.prevent="openTools()"
    >
      <span>Tools</span>

      <v-icon>mdi-tools</v-icon>
    </v-btn>
    </v-bottom-navigation>

    <v-bottom-sheet v-model="toolsOpen" inset max-width="640" content-class="tools-bottom-sheet">
      <SettingsView sheet @close="toolsOpen = false" />
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SettingsView from "@/modules/Settings/view.vue";

export default {
  name: "bottom-navigation",
  data() {
    return {
      pointerMode: "PointerEvent" in window,
      value: "",
      toolsOpen: false,
    };
  },
  components: {
    SettingsView,
  },
  computed: {
    ...mapGetters("employee", ["employee", "employeeAccess"]),
  },
  methods: {
    openTools() {
      this.toolsOpen = true;
    },
  },
};
</script>

<style scoped>
.admin-bottom-nav {
  height: 68px !important;
  border-top: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(13, 27, 45, 0.96) !important;
  box-shadow: 0 -12px 34px rgba(0, 0, 0, 0.2) !important;
  backdrop-filter: blur(16px);
}

.theme--light .admin-bottom-nav {
  background: rgba(255, 255, 255, 0.96) !important;
  border-top-color: #d8e1ed;
  box-shadow: 0 -10px 30px rgba(31, 49, 75, 0.1) !important;
}

.theme--light .admin-bottom-nav ::v-deep .v-btn {
  color: #59687c !important;
}

.admin-bottom-nav ::v-deep .v-btn {
  min-height: 68px;
  border-radius: 0 !important;
  background: transparent !important;
  color: #94a3b8 !important;
}

.admin-bottom-nav ::v-deep .v-btn::before {
  display: none;
}

.admin-bottom-nav ::v-deep .v-btn .v-icon {
  font-size: 25px;
}

.admin-bottom-nav ::v-deep .v-btn span {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.admin-bottom-nav ::v-deep .admin-bottom-nav__button--active {
  color: var(--v-primary-base) !important;
}

.admin-bottom-nav
  ::v-deep
  .admin-bottom-nav__button--active::after {
  position: absolute;
  top: 0;
  right: 22%;
  left: 22%;
  height: 3px;
  border-radius: 0 0 999px 999px;
  background: var(--v-primary-base);
  content: "";
}

.admin-bottom-nav ::v-deep .v-divider {
  border-color: rgba(148, 163, 184, 0.12) !important;
}
</style>

<style>
.tools-bottom-sheet {
  border-radius: 24px 24px 0 0 !important;
  box-shadow: 0 -24px 70px rgba(0, 0, 0, 0.34) !important;
}
</style>
